import { Select } from '@components/core-ui/form-elements/Select';
import styled from 'styled-components';

export const StyledSelect = styled(Select).attrs({
  className: 'form-select w-full',
})`
  width: 100%;
`;
